/// <reference types="./emoji_picker.d.mts" />
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import * as $element from "../../../sketch_lustre/sketch/lustre/element.mjs";
import * as $html from "../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $emojis from "../../ds/emojis/list.mjs";
import * as $s from "../../ds/internals/styles/emoji.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

class Model extends $CustomType {
  constructor(on_submit, on_blur, open, id, filter) {
    super();
    this.on_submit = on_submit;
    this.on_blur = on_blur;
    this.open = open;
    this.id = id;
    this.filter = filter;
  }
}

class OnSubmit extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnBlur extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Open extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Id extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Filter extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

function attributes_to_model(attrs) {
  return $list.fold(
    attrs,
    new Model(new None(), new None(), false, new None(), new None()),
    (all, attr) => {
      if (attr instanceof OnSubmit) {
        let handler = attr[0];
        let _record = all;
        return new Model(
          new Some(handler),
          _record.on_blur,
          _record.open,
          _record.id,
          _record.filter,
        );
      } else if (attr instanceof OnBlur) {
        let handler = attr[0];
        let _record = all;
        return new Model(
          _record.on_submit,
          new Some(handler),
          _record.open,
          _record.id,
          _record.filter,
        );
      } else if (attr instanceof Open) {
        let open$1 = attr[0];
        let _record = all;
        return new Model(
          _record.on_submit,
          _record.on_blur,
          open$1,
          _record.id,
          _record.filter,
        );
      } else if (attr instanceof Id) {
        let id$1 = attr[0];
        let _record = all;
        return new Model(
          _record.on_submit,
          _record.on_blur,
          _record.open,
          new Some(id$1),
          _record.filter,
        );
      } else {
        let filter = attr[0];
        let _record = all;
        return new Model(
          _record.on_submit,
          _record.on_blur,
          _record.open,
          _record.id,
          new Some(filter),
        );
      }
    },
  );
}

export function on_blur(handler) {
  return new OnBlur(handler);
}

export function on_submit(handler) {
  return new OnSubmit(handler);
}

export function id(id) {
  return new Id(id);
}

export function open(open) {
  return new Open(open);
}

function unwrap_attribute(attribute, mapper) {
  let _pipe = attribute;
  let _pipe$1 = $option.map(_pipe, mapper);
  return $option.lazy_unwrap(_pipe$1, $a.none);
}

function view(model) {
  let $ = model.open;
  if ($) {
    return $s.emoji_container(
      toList([]),
      toList([
        $s.emoji_picker_container(
          toList([
            $a.selected(true),
            $a.autofocus(true),
            $a.attribute("tabindex", "-1"),
          ]),
          toList([
            $s.emoji_list(
              toList([]),
              $list.map(
                $emojis.emojis,
                (e) => {
                  return $s.emoji(
                    toList([
                      unwrap_attribute(model.on_blur, $e.on_blur),
                      (() => {
                        let $1 = model.on_submit;
                        if ($1 instanceof Some) {
                          let on_submit$1 = $1[0];
                          return $e.on_click(on_submit$1(e.value));
                        } else {
                          return $a.none();
                        }
                      })(),
                    ]),
                    toList([$html.text(e.value)]),
                  );
                },
              ),
            ),
          ]),
        ),
      ]),
    );
  } else {
    return $element.none();
  }
}

export function emoji_picker(attrs) {
  let model = attributes_to_model(attrs);
  return view(model);
}
